﻿import LfDataService from '../../../Services/LfDataService';
import LfWebService from '../../../Services/LfWebService';

import {
    pageHasErroredAction, 
    pageErrorAction
} from '../../../State/actions';


export const fetchManagedPensionQuestions = (data) => {
    return {
        type: 'FETCH_MANAGED_PENSION_QUESTIONS',
        data: data
    };
}

export const getChaptersAction = (data) => {
    return {
        type: 'CHAPTERS',
        data: data
    };
}


export const getChapterTitlesAction = (data) => {
    return {
        type: 'CHAPTER_TITLES',
        data: data
    };
}


export const getQuestionsAction = (data) => {
    return {
        type: 'QUESTIONS',
        data: data
    };
}


export const pensionWizardFormSubmittedAction = (data) => {
    return {
        type: 'PENSION_WIZARD_FORM_SUBMITTED',
        data: data
    };
}

export const pensionWizardFormSubmitFailedAction = (payload) => {
    return {
        type: 'PENSION_WIZARD_FORM_SUBMIT_FAILED',
        data: !!payload
    };
}

export const applicationStatusAction = (payload) => {
    return {
        type: 'STATUS',
        data: payload
    }
}

export const applicationStatusPendingAction = (payload) => {
    return {
        type: 'STATUS_PENDING',
        data: payload
    }
}

export const setAppIdAction = (payload) => {
    return {
        type: 'APPID',
        data: payload
    }
}

export const setFormIdAction = (payload) => {
    return {
        type: 'FORMID',
        data: payload
    }
}

export const stopAction = (payload) => {
    return {
        type: 'STOP',
        data: payload
    }
}

export const loadingAction = (payload) => {
    return {
        type: 'LOADING',
        data: payload
    }
}

export const setModalContentAction = (payload) => {
    return {
        type: 'TOGGLE_MODAL_CONTENT',
        data: payload
    }
}

export const updateProgressAction = (payload) => {
    return {
        type: 'UPDATE_PROGRESS',
        data: payload
    }
}

export const updateCurrentChapterTitleAction = (payload) => {
    return {
        type: 'CURRENT_CHAPTER_TITLE',
        data: payload
    }
}


export const fetchQuestionsData = () => {

    const lfDataService = new LfDataService();

    return (dispatch) => {

        let result;
        let chapters = []
        let titles = []
        let questions = []

        lfDataService.getManagedPensionQuestions()
            .then(data => {
                result = data;

                dispatch(fetchManagedPensionQuestions(result.questionGroups));
                dispatch(setFormIdAction(result.formId))

                result.questionGroups.forEach(chapter => chapters.push(chapter))
                dispatch(getChaptersAction(chapters))

                chapters.forEach(title => titles.push(title.title))
                dispatch(getChapterTitlesAction(titles))

                chapters.forEach(chapter => questions.push(chapter.questions))
                dispatch(getQuestionsAction(questions))
            })

            .catch(e => {
            dispatch(pageErrorAction(e));
            dispatch(pageHasErroredAction(true));
        });
    };
}

export const updateCurrentProgress = (payload) => {

    return (dispatch) => {
        dispatch(updateProgressAction(payload))
    }
}

export const updateCurrentChapterTitle = (payload) => {
    return (dispatch) => {
        dispatch(updateCurrentChapterTitleAction(payload))
    }
}

export const submitFormData = ( data ) => {

    let response;
    let appId;


    return (dispatch) => {
  
        const lfDataService = new LfDataService();
        lfDataService.submitPensionWizardForm(data)

        .then(result => {
            response = result;

            if (response.success === true) {
                appId = response.applicationId
                dispatch(setAppIdAction(appId))
                dispatch(pensionWizardFormSubmittedAction(true))
                dispatch(pensionWizardFormSubmitFailedAction(false))
            } else {
                dispatch(pensionWizardFormSubmitFailedAction(true))
            } 
        })
            .catch(e => {
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    }
}

export const getApplicationStatus = (data) => {

    const lfDataService = new LfDataService();

    return (dispatch) => {

     
        lfDataService.getManagedPensionApplicationSignatureStatus(data)

            .then(res => {
              dispatch(applicationStatusAction(res.applicationStatus))
        })
    }
}
